module.exports = __webpack_public_path__ + "img/shoping_bag.40f25c53.svg";